const vex = require('vex-js');
vex.registerPlugin(require('vex-dialog'));
vex.defaultOptions.className = 'vex-theme-bottom-right-corner';

export default {
  alert: function(message, type) {
    if (!type) {
      type = 'warning';
    }
    vex.dialog.alert({
      message: message,
      overlayClosesOnClick: true
    });
  },
  confirm: function(message, cb) {
    vex.dialog.confirm({
      overlayClassName: 'confirm-overlay',
      message: message,
      callback: cb
    });
  }
};
